/** `Delete` — in allen vier Ansichten identisch. */

import { Button } from '@/components/ui';

export interface DeleteButtonProps {
  /** Ohne ausgewählten Datensatz ist die Schaltfläche gesperrt. */
  selectedId: number | null;
  onClick(): void | Promise<void>;
}

export function DeleteButton(props: DeleteButtonProps) {
  return (
    <Button
      title="Delete selected entry"
      iconClass="e-icons e-delete"
      className="button-c"
      disabled={props.selectedId === null}
      onClick={() => props.onClick()}
    >
      Delete
    </Button>
  );
}

export default DeleteButton;
